<div>
    <app-title title="2개의 Grid간의 Drag Drop 테스트"></app-title>

    <div [style]="leftAlignStyle" [style.marginRight]="'1%'">
        <div [id]="gridId1" [style]="gridStyle" style="padding:0 20px; box-sizing: border-box;"></div>
    </div>
    <div [style]="leftAlignStyle">
        <div [id]="gridId2" [style]="gridStyle" style="padding:0 20px; box-sizing: border-box;"></div>
    </div>
</div>